"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var omit_1 = tslib_1.__importDefault(require("lodash/omit"));

var registered = [// These props are provided by BaseField
'changed', 'changedMap', 'disabled', 'error', 'errorMessage', 'field', 'fieldType', 'fields', 'findError', 'findField', 'findValue', 'initialCount', 'label', 'name', 'onChange', 'parent', 'placeholder', 'showInlineError', 'submitting', 'transform', 'validating', 'value', // These are used by AutoField
'allowedValues', 'component'];

function filter(props) {
  return omit_1.default(props, registered);
}

function register() {
  var props = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    props[_i] = arguments[_i];
  }

  props.forEach(function (prop) {
    if (!registered.includes(prop)) {
      registered.push(prop);
    }
  });
}

exports.default = Object.assign(filter, {
  register: register,
  registered: registered
});